/* import __COLOCATED_TEMPLATE__ from './company-profile-assets-list-item.hbs'; */
import { A } from '@ember/array';
import { action, computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";
import { absoluteStoryhunterUrl } from "sh-www/utils/url";

export default Component.extend({
  /** @inheritDoc */
  classNames: ['SH-c-company-profile-assets-list-item'],

  /** Register services */
  moment: service(),
  session: service(),

  currentUser: readOnly('session.currentUser'),

  /** @param {Asset|null} */
  asset: null,

  /** @param {Boolean} hasAdminOrCompanyAdminPermission */
  hasAdminOrCompanyAdminPermission: false,

  /** @param {Function} */
  deleteAsset: () => {},

  /** @type {Ember.A<Object>} Menu options for the asset. */
  _assetMenuDropdownOptions: computed('hasAdminOrCompanyAdminPermission', function () {
    const menuOptions = A([]);

    menuOptions.push({
      title: 'Download',
      onClick: () => this.onDownloadClicked(),
    });

    if (!this.hasAdminOrCompanyAdminPermission) {
      return menuOptions;
    }

    menuOptions.pushObject({
      title: 'Delete file',
      onClick: () => this.onDeleteFileAssetClicked(),
    });

    return menuOptions;
  }),

  onDeleteFileAssetClicked: action(function() {
    showModal(this, 'confirmation', {
      titleText: 'Delete file?',
      bodyText: 'Are you sure you want to delete this file? It will not be removed from any projects it is currently attached to.',
      actionButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      isShowCancelButton: true,
      confirmAction: () => this.deleteAsset(this.asset),
    });
  }),

  /** Called when the user clicks to download asset. */
  onDownloadClicked: action(function() {
    window.open(absoluteStoryhunterUrl(`/assets/${this.asset.id}/download`));
  }),
});
